import { useMemo, useState, useCallback } from "react";
import { SnackbarContext } from "../contexts/SnackbarContext";

export default function SnackbarProvider({ children }: any) {
  const [state, setState] = useState({
    open: false,
    closeButton: true,
    message: "",
    severity: "warning",
  });

  const open = useCallback((message: any, severity: any) => {
    setState((prevState) => ({
      ...prevState,
      open: true,
      message,
      severity: severity || "warning",
    }));
  }, []);

  const close = useCallback(() => {
    setState((prevState) => ({ ...prevState, open: false, message: "" }));
  }, []);

  const hideCloseButton = useCallback((buttonState: boolean) => {
    setState((prevState) => ({ ...prevState, closeButton: buttonState }));
  }, []);

  const value = useMemo(
    () => ({
      state,
      open,
      close,
      hideCloseButton,
    }),
    [state, open, close, hideCloseButton],
  );

  return (
    <SnackbarContext.Provider value={value}>
      {children}
    </SnackbarContext.Provider>
  );
}
